// Backend origin. Falls back to the current origin when REACT_APP_BACKEND_URL is
// missing at build time (production deploys route /api to the backend anyway),
// so the app never ends up calling "undefined/api".
const raw = process.env.REACT_APP_BACKEND_URL;
export const BACKEND_URL = raw && raw !== "undefined" ? raw.replace(/\/+$/, "") : "";
export const API_BASE = `${BACKEND_URL}/api`;
